/**
 * Copyright (C) 2021 盈宝信息科技（广州）有限公司 All Rights Reserved.
 */

// import { Toast, Dialog } from 'vant'
import { showToast, showLoadingToast, closeToast,showConfirmDialog  } from 'vant'
import AppTheme from '@/theme/themes'

/**
 * 盈宝Toast
 * @param {String} type 类型
 * @param {String} msg 弹出信息
 */
function wbToast(msg, type = '',times=2000) {
  let html = ''
  switch (type) {
    default:
    case '':
      html = `<div class="wb-toast"><div class="wb-toast-text">${msg}</div></div>`
      break

    case 'error':
      html = `<div class="wb-toast"><img class="wb-toast-icon" src="${new URL(`@/assets/images/icon_wrong2.png`, import.meta.url).href}" /><div class="wb-toast-text">${msg}</div></div>`
      break
  }

  showToast({
    type: 'html',
    message: html,
    duration:times
  })
}

/**
 * 盈宝alert
 * @param {Function} callback 回调
 * @param {String} msg 弹出信息
 * @param {Object} option 配置
 */
function wbAlert(title="", msg="", callback, option = { confirmButtonText: "确认",cancelButtonText:"取消" }) {
  // Dialog.alert({
  //   message: msg,
  //   confirmButtonText: option.btnText,
  //   theme: 'round-button',
  //   className: 'wb-alert',
  //   overlayClass: 'wb-alert-overlay'
  // }).then(() => {
  //   const dCb = Dialog.close
  //   callback(dCb)
  // })
// showDialog({
//     message: msg,
//     confirmButtonText: option.btnText,
//     theme: 'round-button',
//     className: 'wb-alert',
//     overlayClass: 'wb-alert-overlay'
//   }).then(() => {
//     callback?.()
//   })
showConfirmDialog({
  title: title,
  message:msg,
  confirmButtonText:option.confirmButtonText,
  cancelButtonText:option.cancelButtonText
})
  .then(() => {
     callback?.()
  })
  .catch(() => {
    // on cancel
  });
}

/**
 * 盈宝loading
 */
function wbLoading() {
  const loadingGif = AppTheme.getThemeAsset('loadingAnima')
  // Toast.loading({
  //   duration: 0,
  //   forbidClick: true,
  //   className: 'wb-loading',
  //   overlay: true,
  //   icon: loadingGif
  // })
  // return () => Toast.clear(false)
  showLoadingToast({
    duration: 0,
    forbidClick: true,
    className: 'wb-loading',
    overlay: true,
    icon: loadingGif
  })
  return () => closeToast()
}

export { wbToast, wbLoading, wbAlert }
